import { IRGSAutoPlay } from './interfaces';

export const rgsAutoPlaySelectors = {
    isActive: (state: IRGSAutoPlay): IRGSAutoPlay['isActive'] => state.isActive,
};
